import { Form, Input, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['TopUpLink', 'DemoSiteEnabled', 'SelfUseModeEnabled']

export default function OperationSwitchesSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, patch } = options

  return (
    <SettingSectionCard title="运营开关" subtitle="充值链接、演示站点与自用模式" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="充值链接">
            <Input value={get('TopUpLink')} onChange={(v) => patch({ TopUpLink: v })} placeholder="发卡网站购买链接" />
          </Form.Item>
          <Form.Item label="演示站点模式">
            <Switch checked={getBool('DemoSiteEnabled')} onChange={(v) => patch({ DemoSiteEnabled: v })} />
          </Form.Item>
          <Form.Item label="自用模式" extra="开启后不限制必须设置模型倍率">
            <Switch checked={getBool('SelfUseModeEnabled')} onChange={(v) => patch({ SelfUseModeEnabled: v })} />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
